module.exports = __webpack_public_path__ + "img/Sources-icon.3bf3d94a.svg";